import Pinterest from '../../src/legacy/Pinterest';
export default Pinterest;
